"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CalendarWithModal;

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _Calendar = _interopRequireDefault(require("./Calendar"));

var _DaysNameHeader = _interopRequireDefault(require("./DaysNameHeader"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TODAY = new Date();
CalendarWithModal.defaultProps = {
  minDate: TODAY,
  numMonths: 12,
  initialStartDate: null,
  initialEndDate: null,
  format: 'ddd D MMM',
  isModalOpen: false,
  toggleModal: function toggleModal() {},
  onApply: function onApply() {},
  initialShowStartDateText: 'Select your start date',
  initialShowEndDateText: 'Select your end date',
  showFormattedDate: function showFormattedDate(startDate, endDate, format, blankStartDate, blankEndDate) {
    if (!startDate) return blankStartDate;
    if (!endDate) return blankEndDate;
    return (0, _helpers.getFormattedDate)(startDate, endDate, format);
  },
  showNumNights: function showNumNights(startDate, endDate) {
    return "(".concat((0, _helpers.getDiff)(startDate, endDate), " nights)");
  },
  buttonText: 'Apply'
};

function dateReducer(state, value) {
  var userHasAlreadySelectedDates = state.startDate && state.endDate;
  var startDateIsAfterEndDate = (0, _helpers.isAfterDate)(state.startDate)(value);
  var startDateIsSameOfEndDate = (0, _helpers.isSameDate)(state.startDate)(value);

  if (!state.startDate || userHasAlreadySelectedDates || startDateIsAfterEndDate || startDateIsSameOfEndDate) {
    return {
      startDate: value,
      endDate: null
    };
  }

  return {
    startDate: state.startDate,
    endDate: value
  };
}

function CalendarWithModal(props) {
  var minDate = props.minDate,
      numMonths = props.numMonths,
      initialStartDate = props.initialStartDate,
      initialEndDate = props.initialEndDate,
      format = props.format,
      isModalOpen = props.isModalOpen,
      toggleModal = props.toggleModal,
      onApply = props.onApply,
      showNumNights = props.showNumNights,
      showFormattedDate = props.showFormattedDate,
      buttonText = props.buttonText,
      initialShowStartDateText = props.initialShowStartDateText,
      initialShowEndDateText = props.initialShowEndDateText,
      isInvalidDate = props.isInvalidDate;

  var _React$useReducer = _react["default"].useReducer(dateReducer, {
    startDate: initialStartDate,
    endDate: initialEndDate
  }),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      _React$useReducer2$ = _React$useReducer2[0],
      startDate = _React$useReducer2$.startDate,
      endDate = _React$useReducer2$.endDate,
      dispatch = _React$useReducer2[1];

  _react["default"].useEffect(function () {
    // when the selected date range is outside of the viewport of the modal
    // i.e when the user selects dates that are at the bottom of the calendar.
    // then, scroll that month into view.
    var timer = null;

    if (initialStartDate && initialEndDate && isModalOpen) {
      // wait for the modal content to load up
      // to get endDateElem which could be used to scrollIntoView
      timer = setTimeout(function () {
        var endDateElem = Array.from(document.getElementsByClassName('end_date'))[0];
        if (endDateElem) endDateElem.scrollIntoView({
          block: 'center'
        });
      }, 300);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [initialStartDate, initialEndDate, isModalOpen]);

  var selectDates = function selectDates(date) {
    return dispatch(date);
  };

  var handleDoneClick = _react["default"].useCallback(function () {
    onApply(startDate, endDate);
    toggleModal();
  }, [startDate, endDate]);

  var hasDates = startDate && endDate;
  var dates = (0, _helpers.generateMonthsDate)(minDate, numMonths);
  return _react["default"].createElement(_reactstrap.Modal, {
    isOpen: isModalOpen,
    toggle: toggleModal,
    className: "calendar-modal"
  }, _react["default"].createElement(_reactstrap.ModalHeader, {
    toggle: toggleModal
  }, _react["default"].createElement(_DaysNameHeader["default"], null)), _react["default"].createElement(_reactstrap.ModalBody, null, dates.map(function (date) {
    return _react["default"].createElement(_Calendar["default"], {
      monthDate: date,
      onSelect: selectDates,
      startDate: startDate,
      endDate: endDate,
      isInvalidDate: isInvalidDate
    });
  })), _react["default"].createElement(_reactstrap.ModalFooter, null, _react["default"].createElement("p", {
    className: "selected-date"
  }, showFormattedDate && showFormattedDate(startDate, endDate, format, initialShowStartDateText, initialShowEndDateText), ' ', hasDates && showNumNights && showNumNights(startDate, endDate)), _react["default"].createElement(_reactstrap.Button, {
    color: "yellow",
    size: "md",
    disabled: !hasDates,
    onClick: handleDoneClick,
    className: "apply"
  }, buttonText)));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@honeyguide/components/dist/components/DateRangePicker/CalendarWithModal.js
// module id = 733
// module chunks = 2